/** Prerequisites only: provider discovery and the real frame still decide availability. */
export function webFundingMethods(environment, browser = globalThis) {
    if (browser.isSecureContext !== true)
        return [];
    // MoonPay test mode renders its documented test wallet frames without a provisioned wallet.
    if (environment === 'sandbox')
        return ['apple_pay', 'google_pay'];
    const methods = [];
    try {
        if (browser.ApplePaySession?.canMakePayments() === true)
            methods.push('apple_pay');
    }
    catch {
        // Privacy/security policy can deny the browser capability query; fail closed for Apple Pay.
    }
    if (typeof browser.PaymentRequest === 'function')
        methods.push('google_pay');
    return methods;
}
